import { render, staticRenderFns } from "./CTimeButtons.vue?vue&type=template&id=389136d2&scoped=true"
import script from "./CTimeButtons.vue?vue&type=script&lang=js"
export * from "./CTimeButtons.vue?vue&type=script&lang=js"
import style0 from "./CTimeButtons.vue?vue&type=style&index=0&id=389136d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389136d2",
  null
  
)

export default component.exports